import findAllFor from '../filters/find-all-for';

const getSpaceResizeConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.spaceResizable);
};

export default getSpaceResizeConstraintForElement;
